export default "__VITE_ASSET__DCs8cRRH__"